export default function debounce(func: any, wait: any) {
	let timeout: any

	return function executedFunction(...args: any) {
		// This function will be called when the debounced function is invoked
		const later = () => {
			clearTimeout(timeout)
			func(...args) // Call the original function with the arguments
		}

		clearTimeout(timeout)
		timeout = setTimeout(later, wait) // Set a new timeout
	}
}
